// Import of the module

import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type StrategyChild = {
  id: number;
  diff: {
    currency?: string;
    hedge_mode?: string;
  };
  strategy?: string;
};

// Definition of the columns

export const strategy_children_columns: ColumnDef<StrategyChild>[] = [
  {
    accessorKey: "id",
    header: "ID",
  },
  {
    accessorKey: "diff.currency",
    header: "Currency",
    cell: ({ row }) => {
      return row.original.diff?.currency ?? "";
    },
  },
  {
    accessorKey: "diff.hedge_mode",
    header: "Hedge Mode",
    cell: ({ row }) => {
      return row.original.diff?.hedge_mode ?? "";
    },
  },
  {
    accessorKey: "strategy",
    header: "Strategy",
  },
];
